import React from 'react';
import { Paper } from 'material-ui';

const renderRow = (item, index) => (
  <div key={index} style={{ display: 'flex', alignItems: 'center'}}>
    <h4 style={{ marginRight: 8 }}>{item.label}</h4>
    <span> {item.value}</span>
  </div>
)

export default ({ data }) => {
  const items = [
    // {
    //   label: 'Push Title',
    //   value: data.title,
    // },
    // {
    //   label: 'Push Body',
    //   value: data.body,
    // },
    {
      label: 'Android Sound',
      value: data.sound || 'None',
    },
    {
      label: 'Android Color',
      value: data.color || 'None',
    },
    {
      label: 'Action',
      value: data.action || 'Open App',
    },
  ];


  return (
    <div>
      <h2>Push Details</h2>
      <Paper zDepth={4} style={{ padding: 16, backgroundColor: data.color || '#333'}}>
        <h3 style={{ color: 'white'}}>{data.title}</h3>
        <p style={{ color: 'white'}}>{data.body}</p>
      </Paper>
      {items.map(renderRow)}
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/createEditPush/NewPushPreview.js